import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface GraduationCapIconProps {
    width?: number;
    height?: number;
    stroke?: string;
}

const GraduationCapIcon: React.FC<GraduationCapIconProps> = ({
    width = 24,
    height = 24,
    stroke = '#6B7280'
}) => (
    <SVGUniqueID>
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path 
                d="M21.4188 10.9224C21.5978 10.8434 21.7498 10.7136 21.8558 10.5492C21.9617 10.3847 22.0172 10.1927 22.0151 9.99709C22.0131 9.80144 21.9537 9.61068 21.8444 9.44844C21.735 9.2862 21.5804 9.15961 21.3998 9.08436L12.8288 5.18036C12.5683 5.06151 12.2852 5 11.9988 5C11.7124 5 11.4294 5.06151 11.1688 5.18036L2.59882 9.08036C2.42079 9.15833 2.26934 9.28649 2.16299 9.44917C2.05664 9.61185 2 9.802 2 9.99636C2 10.1907 2.05664 10.3809 2.16299 10.5435C2.26934 10.7062 2.42079 10.8344 2.59882 10.9124L11.1688 14.8204C11.4294 14.9392 11.7124 15.0007 11.9988 15.0007C12.2852 15.0007 12.5683 14.9392 12.8288 14.8204L21.4188 10.9224Z" 
                stroke={stroke} 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
            />
            <path 
                d="M22 10V16" 
                stroke={stroke} 
                strokeWidth="2"
                strokeLinecap="round" 
                strokeLinejoin="round" 
                />
            <path 
                d="M6 12.5V16C6 16.7956 6.63214 17.5587 7.75736 18.1213C8.88258 18.6839 10.4087 19 12 19C13.5913 19 15.1174 18.6839 16.2426 18.1213C17.3679 17.5587 18 16.7956 18 16V12.5" 
                stroke={stroke} 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
            />
        </svg>
    </SVGUniqueID>
);

export { GraduationCapIcon };